import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import MobileNav from './components/MobileNav';
import ProjectCommand from './views/ProjectCommand';
import Dashboard from './views/Dashboard';
import Settings from './views/Settings';
import DemoView from './views/Demo';

function App() {
  const [activeTab, setActiveTab] = useState('project');

  const renderMainContent = () => {
    switch (activeTab) {
      case 'dashboard': return <Dashboard onNavigate={setActiveTab} />;
      case 'project': return <ProjectCommand />;
      case 'demo': return <DemoView />;
      case 'settings': return <Settings />;
      default: return (
        <div className="flex items-center justify-center h-full text-[#666] font-mono text-sm">
          Module offline or under construction.
        </div>
      );
    }
  };

  return (
    <div className="flex h-screen bg-[#0a0a0a] overflow-hidden scanlines bg-grid-pattern selection:bg-pink-500 selection:text-white">
      {/* Sidebar for Desktop */}
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />

      {/* Main Content Area */}
      <main className="flex-1 md:ml-64 relative overflow-y-auto pb-24 md:pb-0 z-10 scroll-smooth">
        
        {/* Top ambient glow */}
        <div className="fixed top-0 left-0 right-0 h-[500px] bg-pink-500/[0.03] blur-[150px] pointer-events-none -z-10"></div>
        
        <div className="p-4 md:p-10 lg:p-16 min-h-full">
          {renderMainContent()}
        </div>
      </main>

      {/* Mobile Navigation */}
      <MobileNav activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}

export default App;